/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import AdminRoutes from './admin.routes';
import AdminController from './admin.controller';
import AdminRetryStatisticsController from './retry-statistics.controller';

export default angular.module('tektelic.admin', [])
    .config(AdminRoutes)
    .controller('AdminController', AdminController)
    .controller('AdminRetryStatisticsController', AdminRetryStatisticsController)
    .name;



// WEBPACK FOOTER //
// ./src/app/admin/index.js